// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1m8Ry","file":"styles_file__TnddS"};